import { FooterPlayer } from "./FooterPlayer";

export default FooterPlayer;
